/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PreseasonGameResultControllerService {
    /**
     * @param voivodeship
     * @param county
     * @param dateFrom
     * @param dateTo
     * @param page
     * @param size
     * @returns any OK
     * @throws ApiError
     */
    public static getResults(
        voivodeship?: string,
        county?: string,
        dateFrom?: string,
        dateTo?: string,
        page: number = 0,
        size: number = 20,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/results',
            query: {
                'voivodeship': voivodeship,
                'county': county,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'page': page,
                'size': size,
            },
        });
    }
}
